import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_TRIALPUBLICATIONTYPES_LOAD,
    ACTION_TRIALPUBLICATIONTYPES_LOAD_BY_ID,

    ACTION_TRIALPUBLICATIONTYPES_SAVE,

    ACTION_TRIALPUBLICATIONTYPES_CREATE,

    ITrialPublicationTypeLoadAction,
    ITrialPublicationTypeLoadByIdAction,
    ITrialPublicationTypeLoadFailureAction,
    ITrialPublicationTypeLoadSuccessAction,

    ITrialPublicationTypeSaveAction,
    ITrialPublicationTypeSaveSuccessAction,
    ITrialPublicationTypeSaveFailureAction,

    ITrialPublicationTypeCreateAction,
    ITrialPublicationTypeCreateSuccessAction,
    ITrialPublicationTypeCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/trialPublicationTypes";
import { trialPublicationTypesApi } from "../services/trialPublicationType";


export const
    getTrialPublicationTypesEpic = (action$): Observable<ITrialPublicationTypeLoadSuccessAction | ITrialPublicationTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPUBLICATIONTYPES_LOAD)
            .mergeMap((action: ITrialPublicationTypeLoadAction) => {
                return trialPublicationTypesApi
                    .getTrialPublicationTypes()
                    .map(response =>
                        LoadSuccess(response.trialPublicationTypes, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialPublicationTypeByIdEpic = (action$): Observable<ITrialPublicationTypeLoadSuccessAction | ITrialPublicationTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPUBLICATIONTYPES_LOAD_BY_ID)
            .mergeMap((action: ITrialPublicationTypeLoadByIdAction) => {
                return trialPublicationTypesApi
                    .getTrialPublicationTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialPublicationType, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialPublicationTypeEpic = (action$): Observable<ITrialPublicationTypeSaveSuccessAction | ITrialPublicationTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPUBLICATIONTYPES_SAVE)
            .mergeMap((action: ITrialPublicationTypeSaveAction) => {
                return trialPublicationTypesApi
                    .setTrialPublicationType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialPublicationType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialPublicationTypeEpic = (action$): Observable<ITrialPublicationTypeCreateSuccessAction | ITrialPublicationTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPUBLICATIONTYPES_CREATE)
            .mergeMap((action: ITrialPublicationTypeCreateAction) => {
                return trialPublicationTypesApi
                    .createTrialPublicationType()
                    .map(response =>
                        CreateSuccess(
                            response.trialPublicationType,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



